'use strict';
import luxy from 'luxy.js';

export default () => {
  luxy.init({
    wrapper: '#luxy',
    targets : '.luxy-el'
  });
};
